import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const GEORGETOWN = { lat: 6.8013, lng: -58.1551 };

export function formatGYD(n) {
  if (n == null) return "—";
  return `G$${Number(n).toLocaleString("en-GY")}`;
}
